// Slick Slider
$(document).ready(function(){
 
  // Slider Header-Animation
	$('.slider-header-animation').each(function () {
    var slider = $(this);
    var dotsValue = false;
    var autoplayValue = true;
    if (slider.hasClass('helper')) {
      dotsValue = true;
      autoplayValue = false;
    } 
    slider.on('init', function (e) {
		});
		slider.slick({
      arrows: false,
      dots: dotsValue,
      fade: true,
      //speed: 2000, //300
      speed: 6000, 
      infinite: true,
      autoplay: autoplayValue,
      autoplaySpeed: 1500,
      pauseOnHover: false,
			slidesToShow: 1,
      adaptiveHeight: false,
		});
		slider.on('setPosition', function (e) {
		});
	});  

  // Slider Full
	$('.slider-full').each(function () {
		var slider = $(this);
    function positionSliderTeaserArrows(slider) {
			var imgHeight = slider.find('img').first().outerHeight();
			var positionTop = (imgHeight / 2) + 'px';
			slider.find('.slick-prev, .slick-next').css('top', positionTop);
    }
    slider.on('init', function (e) {
			positionSliderTeaserArrows(slider);
		});
		slider.slick({
      arrows: true,
      dots: false,
      fade: true,
      infinite: false,
			slidesToShow: 1,
      adaptiveHeight: true,
		});
		slider.on('setPosition', function (e) {
			positionSliderTeaserArrows(slider);
		});
	});  

  // Slider Tiles
	$('.slider-tiles').each(function () {
    var slider = $(this);
		slider.slick({
      arrows: true,
      dots: false,
      fade: true,
      infinite: false,
			slidesToShow: 1,
      adaptiveHeight: true,
      prevArrow: slider.parent().find('.prev-desktop'),
      nextArrow: slider.parent().find('.next-desktop'),
      responsive: [
				{
					breakpoint: 992,
					settings: {
						arrows: true,
            dots: false,
            fade: true,
            infinite: false,
            slidesToShow: 1,
            adaptiveHeight: true,
            prevArrow: slider.find('.tiles-img-wrapper .prev-mobil'),
            nextArrow: slider.find('.tiles-img-wrapper .next-mobil')
					}
				},
			]
    });
	});  

	// Teaser Slider
	$('.slider-teaser').each(function () {
		var slider = $(this);
		function positionSliderTeaserArrows(slider) {
			var imgHeight = slider.find('.teaser-img').first().outerHeight();
			var positionTop = (imgHeight / 2) + 'px';
			slider.find('.slick-prev, .slick-next').css('top', positionTop);
			//console.log('ArrowsTop: '+positionTop);
    }
    slider.on('init', function (e) {
			positionSliderTeaserArrows(slider);
			//console.log('Init');
			$.fn.matchHeight._update();
		});
  	slider.slick({
      infinite: false,
			slidesToShow: 3,
			slidesToScroll: 1,
			dots: false,
			responsive: [
				{
					breakpoint: 1380,
					settings: {
						infinite: false,
						slidesToShow: 2,
						slidesToScroll: 1,
						dots: false
					}
				},
				{
					breakpoint: 992,
					settings: {
						infinite: false,
						slidesToShow: 2,
						slidesToScroll: 1,
						dots: false
					}
				},
				{
					breakpoint: 768,
					settings: {
						infinite: false,
						slidesToShow: 1,
						slidesToScroll: 1,
						dots: false
					}
				}
			]
		});
		slider.on('setPosition', function (e) {
      positionSliderTeaserArrows(slider);
      $.fn.matchHeight._update();
			//console.log('SetPosition');
		});
  });  
  
  // Slider Gallery
  $('.slider-gallery').each(function () {
		var slider = $(this);
		slider.slick({
      arrows: true,
      dots: false,
      fade: true,
      infinite: false,
			slidesToShow: 1,
      adaptiveHeight: false,
		});
	});  
 
 
  // History Slider
	$('.history-slider-content').each(function () {
		var slider = $(this);
		slider.slick({
			arrows: true,
			dots: false,
			infinite: false,
			fade: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			rtl: true,
			asNavFor: '.history-slider-nav',
			appendArrows: slider.parent().find('.history-slider-nav-outer .container')
		});
	});  
    
  // History Slider Nav
	$('.history-slider-nav').each(function () {
		var slider = $(this);
		slider.slick({
			arrows: false,
			dots: false,
			infinite: false,
			slidesToShow: 8,
			slidesToScroll: 1,
			adaptiveHeight: false,
			focusOnSelect: true,
			rtl: true,
			asNavFor: '.history-slider-content',
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						arrows: false,
						dots: false,
						infinite: false,
						slidesToShow: 6,
						slidesToScroll: 1,
						adaptiveHeight: false,
						focusOnSelect: true,
						rtl: true,
						asNavFor: '.history-slider-content',
					}
				},
				{
					breakpoint: 992,
					settings: {
						arrows: false,
						dots: false,
						infinite: false,
						slidesToShow: 4,
						slidesToScroll: 1,
						adaptiveHeight: false,
						focusOnSelect: true,
						rtl: true,
						asNavFor: '.history-slider-content',
					}
				},
				{
					breakpoint: 768,
					settings: {
						arrows: false,
						dots: false,
						infinite: false,
						slidesToShow: 3,
						slidesToScroll: 1,
						adaptiveHeight: false,
						focusOnSelect: true,
						rtl: true,
						asNavFor: '.history-slider-content',
					}
				},
				{
					breakpoint: 500,
					settings: {
						arrows: false,
						dots: false,
						infinite: false,
						slidesToShow: 2,
						slidesToScroll: 1,
						adaptiveHeight: false,
						focusOnSelect: true,
						rtl: true,
						asNavFor: '.history-slider-content',
					}
				}
			]
		});

		// Press Arrow
		var timeoutHistorySlider;
		var prevButton = slider.parent().find('.slick-prev.slick-arrow');
		var nextButton = slider.parent().find('.slick-next.slick-arrow');

		prevButton.bind("mousedown touchstart", function(){
			timeoutHistorySlider = setInterval(function(){
				//console.log('PREV');
				slider.slick('slickPrev');
			}, 100);
			return false;
		});
		prevButton.bind("mouseup touchend", function(){
			clearInterval(timeoutHistorySlider);
			//console.log('clearInterval');
			return false;
		});

		nextButton.bind("mousedown touchstart", function(){
			timeoutHistorySlider = setInterval(function(){
				//console.log('NEXT');
				slider.slick('slickNext');
			}, 100);
			return false;
		});
		nextButton.bind("mouseup touchend", function(){
			clearInterval(timeoutHistorySlider);
			//console.log('clearInterval');
			return false;
		});


	}); 


});


// WEBPACK FOOTER //
// ./js/parts/slick.js